import moment from "moment";

export const getDates = (viewMode, selectedDate) => {
  if (viewMode === "daily") return [selectedDate];
  if (viewMode === "weekly") {
    const start = selectedDate.clone().startOf("week");
    return Array.from({ length: 7 }, (_, i) => start.clone().add(i, "days"));
  }
  const start = selectedDate.clone().startOf("month");
  const end = selectedDate.clone().endOf("month");
  return Array.from({ length: end.diff(start, "days") + 1 }, (_, i) =>
    start.clone().add(i, "days")
  );
};

export const getStartAndEndDate = (selectedDate, viewMode) => {
  let startDate, endDate;
  if (viewMode === "daily") {
    startDate = selectedDate.clone().format("YYYY-MM-DD");
    endDate = selectedDate.clone().format("YYYY-MM-DD");
  } else if (viewMode === "weekly") {
    startDate = selectedDate.clone().startOf("week").format("YYYY-MM-DD");
    endDate = selectedDate.clone().endOf("week").format("YYYY-MM-DD");
  } else {
    startDate = selectedDate.clone().startOf("month").format("YYYY-MM-DD");
    endDate = selectedDate.clone().endOf("month").format("YYYY-MM-DD");
  }
  return { startDate, endDate };
};
